<template>
  <v-stepper
    :value="currentStep"
    flat
    class="wizard-stepper"
  >
    <v-stepper-header>
      <template v-for="(name, idx) in stepNames">
        <v-stepper-step
          :key="`step-${idx}`"
          :step="idx + 1"
          :complete="idx + 1 < currentStep"
          :editable="canNavigateTo(idx + 1)"
          @click="handleClick(idx + 1)"
        >
          {{ name }}
        </v-stepper-step>
        <v-divider
          v-if="idx < stepNames.length - 1"
          :key="`divider-${idx}`"
        />
      </template>
    </v-stepper-header>
  </v-stepper>
</template>

<script>
export default {
  name: 'WizardStepper',
  props: {
    currentStep: { type: Number, required: true },
    stepNames: { type: Array, required: true },
    // 現在ステップのバリデーションが通っていない場合 true（次へボタンと同じ条件）
    nextDisabled: { type: Boolean, default: false },
  },
  emits: ['navigate'],
  setup(props, { emit }) {
    // 通過済みステップは常に / 先のステップは現在ステップが valid な時だけジャンプ可
    const canNavigateTo = step => {
      if (step <= props.currentStep) return true

      return !props.nextDisabled
    }

    const handleClick = step => {
      if (!canNavigateTo(step)) return
      if (step === props.currentStep) return
      emit('navigate', step)
    }

    return { canNavigateTo, handleClick }
  },
}
</script>
